export default "/assets/images/column-image8.c68a51d6e879e7e6.jpg";